import { defineAsyncComponent } from "vue";

const LfInput = defineAsyncComponent(
  () => import("@/components/ui/inputs/LfInput.vue")
);

const SearchInput = defineAsyncComponent(
  () => import("@/components/ui/inputs/SearchInput.vue")
);

const LfLink = defineAsyncComponent(() => import("@/components/ui/LfLink.vue"));

const LfTextarea = defineAsyncComponent(
  () => import("@/components/ui/inputs/LfTextarea.vue")
);

const IconBase = defineAsyncComponent(
  () => import("@/components/ui/IconBase.vue")
);

const PrimaryButton = defineAsyncComponent(
  () => import("@/components/ui/buttons/PrimaryButton.vue")
);

const OutlineButton = defineAsyncComponent(
  () => import("@/components/ui/buttons/OutlineButton.vue")
);

const LfDatePicker = defineAsyncComponent(
  () => import("@/components/ui/inputs/LfDatePicker.vue")
);

const LfDetails = defineAsyncComponent(
  () => import("@/components/ui/LfDetails.vue")
);

const DateTimeInput = defineAsyncComponent(
  () => import("@/components/ui/inputs/DateTimeInput.vue")
);

const PaymentFrequencyDropdown = defineAsyncComponent(
  () => import("@/views/deals/components/PaymentFrequencyDropdown.vue")
);

const LfButton = defineAsyncComponent(
  () => import("@/components/ui/buttons/LfButton.vue")
);

const ColorButton = defineAsyncComponent(
  () => import("@/components/ui/buttons/ColorButton.vue")
);

const LfTab = defineAsyncComponent(() => import("@/components/ui/LfTab.vue"));

const LfHeading1 = defineAsyncComponent(
  () => import("@/components/ui/text/LfHeading1.vue")
);

const LfHeading2 = defineAsyncComponent(
  () => import("@/components/ui/text/LfHeading2.vue")
);

const LfHeading3 = defineAsyncComponent(
  () => import("@/components/ui/text/LfHeading3.vue")
);

const LfHeading4 = defineAsyncComponent(
  () => import("@/components/ui/text/LfHeading4.vue")
);

const LfPill = defineAsyncComponent(
  () => import("@/components/ui/text/LfPill.vue")
);

const StatusPill = defineAsyncComponent(
  () => import("@/components/ui/StatusPill.vue")
);

const OfferStatusPill = defineAsyncComponent(
  () => import("@/components/ui/OfferStatusPill.vue")
);

const OfferPillDropdown = defineAsyncComponent(
  () => import("@/components/ui/OfferPillDropdown.vue")
);

const OfferContactedVia = defineAsyncComponent(
  () => import("@/components/ui/OfferContactedVia.vue")
);

const OfferDeleteButton = defineAsyncComponent(
  () => import("@/components/ui/buttons/OfferDeleteButton.vue")
);

const PlacementStatus = defineAsyncComponent(
  () => import("@/components/ui/PlacementStatus.vue")
);

const LfPieChart = defineAsyncComponent(
  () => import("@/components/ui/LfPieChart.vue")
);

const AssignUserField = defineAsyncComponent(
  () => import("@/views/deals/components/AssignUserField.vue")
);

const ButtonCreateOffer = defineAsyncComponent(
  () => import("@/views/deals/components/ButtonCreateOffer.vue")
);

const ButtonEditOffer = defineAsyncComponent(
  () => import("@/views/deals/components/ButtonEditOffer.vue")
);

const OfferDropdownMenu = defineAsyncComponent(
  () => import("@/views/deals/components/OfferDropdownMenu.vue")
);

const LfDate = defineAsyncComponent(() => import("@/components/ui/LfDate.vue"));

const LfDropdown = defineAsyncComponent(
  () => import("@/components/ui/inputs/LfDropdown.vue")
);

const LfDropdownWithApiSearch = defineAsyncComponent(
  () => import("@/components/ui/inputs/LfDropdownWithApiSearch.vue")
);

const LfCheckboxDropdown = defineAsyncComponent(
  () => import("@/components/ui/inputs/LfCheckboxDropdown.vue")
);

const LfBadge = defineAsyncComponent(
  () => import("@/components/ui/LfBadge.vue")
);

const LfChip = defineAsyncComponent(() => import("@/components/ui/LfChip.vue"));

const LfStatus = defineAsyncComponent(
  () => import("@/components/ui/LfStatus.vue")
);

const EditButton = defineAsyncComponent(
  () => import("@/components/ui/buttons/EditButton.vue")
);

const LfCurrency = defineAsyncComponent(
  () => import("@/components/ui/inputs/LfCurrency.vue")
);

const DocumentsListItemActionBtn = defineAsyncComponent(
  () => import("@/components/deals/documents/DocumentsListItemActionBtn.vue")
);

const UserProfile = defineAsyncComponent(
  () => import("@/components/UserProfile.vue")
);

const EditRowButton = defineAsyncComponent(
  () => import("@/components/ui/EditRowButton.vue")
);

const ClientModal = defineAsyncComponent(
  () => import("@/views/profile/modals/ClientModal.vue")
);

const UserModal = defineAsyncComponent(
  () => import("@/views/profile/modals/UserModal.vue")
);

const AssignWorkflowDropdown = defineAsyncComponent(
  () => import("@/views/profile/components/AssignWorkflowDropdown.vue")
);

const Loader = defineAsyncComponent(() => import("@/components/ui/Loader.vue"));

const LfExternalLink = defineAsyncComponent(
  () => import("@/components/ui/text/LfExternalLink.vue")
);

const AccessControl = defineAsyncComponent(
  () => import("@/components/AccessControl.vue")
);

const LfCard = defineAsyncComponent(() => import("@/components/ui/LfCard.vue"));

const LfScrollableMenu = defineAsyncComponent(
  () => import("@/components/ui/LfScrollableMenu.vue")
);

const RoundButton = defineAsyncComponent(
  () => import("@/components/ui/buttons/RoundButton.vue")
);

const CircleProgress = defineAsyncComponent(
  () => import("@/components/ui/CircleProgress.vue")
);

const Progress = defineAsyncComponent(
  () => import("@/components/ui/Progress.vue")
);

const FunderModal = defineAsyncComponent(
  () => import("@/components/funders/FunderModal.vue")
);

const FunderUserModal = defineAsyncComponent(
  () => import("@/views/profile/modals/FunderUserModal.vue")
);

const ContactModal = defineAsyncComponent(
  () => import("@/components/funders/ContactModal.vue")
);

const ContactModalTableButton = defineAsyncComponent(
  () => import("@/components/funders/ContactModalTableButton.vue")
);

const SalesRepModal = defineAsyncComponent(
  () => import("@/views/profile/modals/SalesRepModal.vue")
);

const SalesRepModalTableButton = defineAsyncComponent(
  () => import("@/views/profile/components/SalesRepModalTableButton.vue")
);

const DownloadServiceButton = defineAsyncComponent(
  () =>
    import("@/views/businessCreditDeals/components/DownloadServiceButton.vue")
);

const ServiceWrapper = defineAsyncComponent(
  () => import("@/components/deals/dataServices/ServiceWrapper.vue")
);

const LfSwitch = defineAsyncComponent(
  () => import("@/components/ui/inputs/LfSwitch.vue")
);

const LfButtonToggle = defineAsyncComponent(
  () => import("@/components/ui/inputs/LfButtonToggle.vue")
);

const IconSort = defineAsyncComponent(
  () => import("@/components/icons/IconSort.vue")
);

const IconChevronRight = defineAsyncComponent(
  () => import("@/components/icons/IconChevronRight.vue")
);

const IconCopyFilled = defineAsyncComponent(
  () => import("@/components/icons/IconCopyFilled.vue")
);

const IconDownload = defineAsyncComponent(
  () => import("@/components/icons/IconDownload.vue")
);

const IconDelete = defineAsyncComponent(
  () => import("@/components/icons/IconDelete.vue")
);

const IconProfileNoBg = defineAsyncComponent(
  () => import("@/components/icons/sidebar/IconProfileNoBg.vue")
);

const IconProfileSmall = defineAsyncComponent(
  () => import("@/components/icons/IconProfileSmall.vue")
);

const IconProfileSmallNoBackground = defineAsyncComponent(
  () => import("@/components/icons/IconProfileSmallNoBackground.vue")
);

const IconAddress = defineAsyncComponent(
  () => import("@/components/icons/IconAddress.vue")
);

const IconAddressNoFill = defineAsyncComponent(
  () => import("@/components/icons/IconAddressNoFill.vue")
);

const IconLink = defineAsyncComponent(
  () => import("@/components/icons/IconLink.vue")
);

const IconReload = defineAsyncComponent(
  () => import("@/components/icons/IconReload.vue")
);

const IconStar = defineAsyncComponent(
  () => import("@/components/icons/IconStar.vue")
);

const IconChevronDown = defineAsyncComponent(
  () => import("@/components/icons/deals/IconChevronDown.vue")
);

const IconChevronUp = defineAsyncComponent(
  () => import("@/components/icons/deals/IconChevronUp.vue")
);

const IconX = defineAsyncComponent(
  () => import("@/components/icons/deals/IconX.vue")
);

const IconXCircle = defineAsyncComponent(
  () => import("@/components/icons/IconXCircle.vue")
);

const IconPin = defineAsyncComponent(
  () => import("@/components/icons/IconPin.vue")
);

const IconWarning = defineAsyncComponent(
  () => import("@/components/icons/IconWarning.vue")
);

const RiskTiersList = defineAsyncComponent(
  () => import("@/components/ui/RiskTiersList.vue")
);

const PersonaFailureReason = defineAsyncComponent(
  () =>
    import("@/views/businessCreditDeals/components/PersonaFailureReason.vue")
);

const EkataDataField = defineAsyncComponent(
  () => import("@/views/deals/components/EkataDataField.vue")
);

const CFADynamicTable = defineAsyncComponent(
  () => import("@/views/deals/components/CFADynamicTable.vue")
);

const CFAList = defineAsyncComponent(
  () => import("@/views/deals/components/CFAList.vue")
);

const EkataWarningsField = defineAsyncComponent(
  () => import("@/views/deals/components/EkataWarningsField.vue")
);

const SuccessIndicator = defineAsyncComponent(
  () => import("@/components/ui/SuccessIndicator.vue")
);

const DunAndBradstreetApiIcon = defineAsyncComponent(
  () => import("@/components/icons/api/dunandbradstreet.vue")
);

const EkataApiIcon = defineAsyncComponent(
  () => import("@/components/icons/api/ekata.vue")
);

const LexisNexisApiIcon = defineAsyncComponent(
  () => import("@/components/icons/api/lexisnexis.vue")
);

const ExperianApiIcon = defineAsyncComponent(
  () => import("@/components/icons/api/experian.vue")
);

const InscribeApiIcon = defineAsyncComponent(
  () => import("@/components/icons/api/inscribe.vue")
);

const MiddeskApiIcon = defineAsyncComponent(
  () => import("@/components/icons/api/middesk.vue")
);

const OcrolusApiIcon = defineAsyncComponent(
  () => import("@/components/icons/api/ocrolus.vue")
);

const PersonaApiIcon = defineAsyncComponent(
  () => import("@/components/icons/api/persona.vue")
);

const SentilinkApiIcon = defineAsyncComponent(
  () => import("@/components/icons/api/sentilink.vue")
);

const SocureApiIcon = defineAsyncComponent(
  () => import("@/components/icons/api/socure.vue")
);

const PlaidApiIcon = defineAsyncComponent(
  () => import("@/components/icons/api/plaid.vue")
);

const ClearApiIcon = defineAsyncComponent(
  () => import("@/components/icons/api/clear.vue")
);

const EquifaxApiIcon = defineAsyncComponent(
  () => import("@/components/icons/api/equifax.vue")
);

const CodatApiIcon = defineAsyncComponent(
  () => import("@/components/icons/api/codat.vue")
);

const RutterApiIcon = defineAsyncComponent(
  () => import("@/components/icons/api/rutter.vue")
);

const MoneyThumbApiIcon = defineAsyncComponent(
  () => import("@/components/icons/api/moneythumb.vue")
);

const ActionMenuItem = defineAsyncComponent(
  () => import("@/components/ui/ActionMenuItem.vue")
);

const LfContentLoader = defineAsyncComponent(
  () => import("@/components/ui/LfContentLoader.vue")
);

const LogicalIndicator = defineAsyncComponent(
  () => import("@/components/LogicalIndicator.vue")
);

const LfLogicalSwitch = defineAsyncComponent(
  () => import("@/components/ui/inputs/LfLogicalSwitch.vue")
);

const LfButtonSelectArray = defineAsyncComponent(
  () => import("@/components/ui/inputs/LfButtonSelectArray.vue")
);

const LfButtonSelectString = defineAsyncComponent(
  () => import("@/components/ui/inputs/LfButtonSelectString.vue")
);

const ServiceNode = defineAsyncComponent(
  () => import("@/views/profile/components/dataOrchestration/ServiceNode.vue")
);

const ConditionalArgumentNode = defineAsyncComponent(
  () =>
    import(
      "@/views/profile/components/dataOrchestration/ConditionalArgumentNode.vue"
    )
);

const DoStep = defineAsyncComponent(
  () => import("@/views/profile/components/dataOrchestration/DoStep.vue")
);

const DoMonthPicker = defineAsyncComponent(
  () =>
    import(
      "@/views/profile/components/dataOrchestration/configPanel/DOMonthPicker.vue"
    )
);

const PlacementMethodDropdown = defineAsyncComponent(
  () => import("@/components/deals/placement/PlacementMethodDropdown.vue")
);

const IconOffer = defineAsyncComponent(
  () => import("@/components/icons/IconOffer.vue")
);

const StageEditButton = defineAsyncComponent(
  () => import("@/components/deals/workflow/StageEditButton.vue")
);

const IconCheck = defineAsyncComponent(
  () => import("@/components/icons/IconCheck.vue")
);

const WorkflowCategoryPill = defineAsyncComponent(
  () => import("@/components/ui/WorkflowCategoryPill.vue")
);

const ViewWrapper = defineAsyncComponent(
  () => import("@/views/ViewWrapper.vue")
);

const WorkflowTabEditButton = defineAsyncComponent(
  () => import("@/components/deals/workflow/TabsEditButton.vue")
);

const DropdownChevron = defineAsyncComponent(
  () => import("@/components/ui/DropdownChevron.vue")
);

const AvailabilityButton = defineAsyncComponent(
  () => import("@/components/ui/AvailabilityButton.vue")
);

const StageBlock = defineAsyncComponent(
  () => import("@/components/deals/workflow/StageBlock.vue")
);

const IDescription = defineAsyncComponent(
  () => import("@/components/icons/IconDescription.vue")
);

const NotAvailableComponent = defineAsyncComponent(
  () => import("@/components/ui/NotAvailable.vue")
);

const CreateButton = defineAsyncComponent(
  () => import("@/components/ui/buttons/CreateButton.vue")
);

const SelectorButton = defineAsyncComponent(
  () => import("@/components/ui/buttons/SelectorButton.vue")
);

const LFAvatar = defineAsyncComponent(() =>
  import("@lendflow/ui").then((module) => module.Avatar)
);

const ToggleAllIcon = defineAsyncComponent(
  () => import("@/components/ToggleAllIcon.vue")
);

export default {
  "lf-input": LfInput,
  "search-input": SearchInput,
  "lf-link": LfLink,
  "lf-textarea": LfTextarea,
  "lf-h1": LfHeading1,
  "lf-h2": LfHeading2,
  "lf-h3": LfHeading3,
  "lf-h4": LfHeading4,
  "ekata-data-field": EkataDataField,
  "ekata-warnings-field": EkataWarningsField,
  "success-indicator": SuccessIndicator,
  "failure-reasons": PersonaFailureReason,
  "primary-button": PrimaryButton,
  "outline-button": OutlineButton,
  "lf-date-picker": LfDatePicker,
  "date-time-input": DateTimeInput,
  "color-button": ColorButton,
  "lf-button": LfButton,
  "lf-tab": LfTab,
  "lf-pill": LfPill,
  "status-pill": StatusPill,
  "offer-status-pill": OfferStatusPill,
  "offer-pill-dropdown": OfferPillDropdown,
  "offer-contacted-via": OfferContactedVia,
  "offer-delete-button": OfferDeleteButton,
  "placement-status": PlacementStatus,
  "lf-pie-chart": LfPieChart,
  "assign-user-field": AssignUserField,
  "payment-frequency-dropdown": PaymentFrequencyDropdown,
  "lf-date": LfDate,
  "lf-dropdown": LfDropdown,
  "lf-dropdown-with-api-search": LfDropdownWithApiSearch,
  "lf-checkbox-dropdown": LfCheckboxDropdown,
  "lf-badge": LfBadge,
  "lf-chip": LfChip,
  "lf-status": LfStatus,
  "edit-button": EditButton,
  "button-create-offer": ButtonCreateOffer,
  "button-edit-offer": ButtonEditOffer,
  "offer-dropdown-menu": OfferDropdownMenu,
  "lf-currency": LfCurrency,
  "documents-list-item-action-btn": DocumentsListItemActionBtn,
  "user-profile": UserProfile,
  "edit-row-button": EditRowButton,
  "client-modal": ClientModal,
  "user-modal": UserModal,
  "assign-workflow-dropdown": AssignWorkflowDropdown,
  loader: Loader,
  "lf-external-link": LfExternalLink,
  "access-control": AccessControl,
  "lf-card": LfCard,
  "lf-scrollable-menu": LfScrollableMenu,
  "lf-round-button": RoundButton,
  "lf-circle-progress": CircleProgress,
  "lf-progress": Progress,
  "lf-details": LfDetails,
  "funder-modal": FunderModal,
  "funder-user-modal": FunderUserModal,
  "contact-modal": ContactModal,
  "contact-modal-table-button": ContactModalTableButton,
  "sales-rep-modal": SalesRepModal,
  "sales-rep-modal-table-button": SalesRepModalTableButton,
  "download-service-button": DownloadServiceButton,
  "service-wrapper": ServiceWrapper,
  "cfa-dynamic-table": CFADynamicTable,
  "cfa-list": CFAList,
  "lf-switch": LfSwitch,
  "lf-button-toggle": LfButtonToggle,
  "lf-content-loader": LfContentLoader,
  "service-node": ServiceNode,
  "conditional-argument-node": ConditionalArgumentNode,
  "do-step": DoStep,
  "do-month-picker": DoMonthPicker,
  "icon-base": IconBase,
  "icon-sort": IconSort,
  "icon-chevron-right": IconChevronRight,
  "icon-copy-filled": IconCopyFilled,
  "icon-download": IconDownload,
  "icon-delete": IconDelete,
  "icon-profile-small": IconProfileSmall,
  "icon-profile-small-no-bg": IconProfileSmallNoBackground,
  "icon-chevron-down": IconChevronDown,
  "icon-chevron-up": IconChevronUp,
  "icon-warning": IconWarning,
  "icon-profile-no-bg": IconProfileNoBg,
  "icon-x": IconX,
  "icon-x-circle": IconXCircle,
  "icon-address": IconAddress,
  "icon-address-no-fill": IconAddressNoFill,
  "icon-link": IconLink,
  "icon-reload": IconReload,
  "icon-star": IconStar,
  "icon-pin": IconPin,
  "risk-tier-list": RiskTiersList,
  "action-menu-item": ActionMenuItem,
  "dnb-api-icon": DunAndBradstreetApiIcon,
  "ekata-api-icon": EkataApiIcon,
  "experian-api-icon": ExperianApiIcon,
  "inscribe-api-icon": InscribeApiIcon,
  "middesk-api-icon": MiddeskApiIcon,
  "ocrolus-api-icon": OcrolusApiIcon,
  "persona-api-icon": PersonaApiIcon,
  "sentilink-api-icon": SentilinkApiIcon,
  "clear-api-icon": ClearApiIcon,
  "socure-api-icon": SocureApiIcon,
  "lexisnexis-api-icon": LexisNexisApiIcon,
  "rutter-api-icon": RutterApiIcon,
  "plaid-api-icon": PlaidApiIcon,
  "equifax-api-icon": EquifaxApiIcon,
  "codat-api-icon": CodatApiIcon,
  "moneythumb-api-icon": MoneyThumbApiIcon,
  "logical-indicator": LogicalIndicator,
  "logical-switch": LfLogicalSwitch,
  "lf-button-select-array": LfButtonSelectArray,
  "lf-button-select-string": LfButtonSelectString,
  "placement-method-dropdown": PlacementMethodDropdown,
  "icon-offer": IconOffer,
  "stage-edit-button": StageEditButton,
  "workflow-category-pill": WorkflowCategoryPill,
  "view-wrapper": ViewWrapper,
  "workflow-tab-edit-button": WorkflowTabEditButton,
  "dropdown-chevron": DropdownChevron,
  "availability-button": AvailabilityButton,
  "stage-block": StageBlock,
  "icon-check": IconCheck,
  "icon-description": IDescription,
  "not-available": NotAvailableComponent,
  "create-button": CreateButton,
  "selector-button": SelectorButton,
  "lf-avatar": LFAvatar,
  "toggle-all-icon": ToggleAllIcon,
};
